export default {"src":"/_next/static/media/quote-icon.3078b106.svg","height":88,"width":88,"blurWidth":0,"blurHeight":0};